<template>
	<div class="zjpl">
		<!-- zjpl -->
		<ul class="title1">
			<li class="L"><router-link to="/pinglun">中经评论</router-link></li>
			<li class="M"></li>
			<li class="R"><router-link to="/pinglun" class="more3">更多</router-link></li>
		</ul>
		<el-skeleton :rows="11" :loading="isloading" animated >
			<div class="zjpl_list">
				<!-- zjpl_list -->
				<li v-for="(item,index) in pinglunList">
					<dl>
						<dt>
							<L>
								<a @click="jumppush('/detail/'+item.id+'?favtype=4&col=pinglun')">{{item.title}}</a>
							</L>
						</dt>
						<!-- <dd style="white-space: normal;">{{item.summary&&item.summary.length>140?item.summary.substring(0,140)+'...':item.summary}}</dd> -->
						<dd style="white-space: normal; display: -webkit-box;overflow: hidden;text-overflow: ellipsis;-webkit-box-orient: vertical;-webkit-line-clamp: 2;">{{item.summary}}</dd>
					</dl>
				</li>
				<!-- <el-row v-for="(item,index) in pinglunList" style="padding: 10px;">
					<el-col :span="1">
						<div><i class="el-icon-caret-right"></i></div>
					</el-col>
					<el-col :span="23">
						<el-row>
							<el-col :span="22">
								<router-link :to="{ name: 'detail', params: { id: item.id }}" style="font-size: 20px;">{{item.title}}</router-link>
							</el-col>
							<el-col :span="2">{{item.publishtime.substring(5,10).replace('-','/')}}</el-col>
						</el-row>
						<el-row>
							<el-col :span="24">
								<p style="color: #a1a4ab;">{{item.summary&&item.summary.length>80?item.summary.substring(0,80)+'...':item.summary}}</p>
							</el-col>
						</el-row>
					</el-col>
				</el-row> -->
			</div><!-- /zjpl_list -->
		</el-skeleton>
	</div><!-- /zjpl -->
</template>

<script>
	export default {
		data() {
			return {
				isloading:true,
				pinglunList: [],
			}
		},
		created: function() {
			this.pinglunfnc();
		},
		computed: {
	
		},
		methods: {
			showLogin: function() {
				this.$emit('showLogin');
			},
			jumppush:function(to){
				if(!this.$cookies.get('userinfo')){
					this.showLogin();
					this.$cookies.set('fromdetail',to);
					return false;
				}
				else{
					var a = document.createElement('a');
					a.setAttribute('href', to);
					a.setAttribute('style', 'display:none');  
					a.setAttribute('target', '_blank');  
					document.body.appendChild(a);
					a.click();
					a.parentNode.removeChild(a); 
				}
			},
			pinglunfnc: function() {
				let _this = this;
				this.$http({
						method: 'get',
						url: 'searchArticles',
						responseType: 'json',
						params: {
							columnID: '6a79e1b0f6d7411583d38c43c4e3eafc',
							// isTopArticle: '1',
							iPage:'1',
							pageSize:'5',
							tagName:'评论',
						},
					})
					.then(function(response) {
						_this.pinglunList = response.data.data.data.data;
						_this.isloading=false;
					})
					.catch(function(error) {
						console.log(error);
						_this.isloading=false;
					});
			},
		}
	}
</script>

<style>
	.zjpl_list dl:hover a{
		color: #bd1a2d;
	}
</style>
